export default __webpack_public_path__ + "static/og-home-page-1ddf6be15eca552b3d0bb3b16cd2a0c3.png";